/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Accessdataroom_Dataroomtitle5Inputs */

const en_coinvestments_accessdataroom_dataroomtitle5 = /** @type {(inputs: Coinvestments_Accessdataroom_Dataroomtitle5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data room access`)
};

/**
* | output |
* | --- |
* | "Data room access" |
*
* @param {Coinvestments_Accessdataroom_Dataroomtitle5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_accessdataroom_dataroomtitle5 = /** @type {((inputs?: Coinvestments_Accessdataroom_Dataroomtitle5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Accessdataroom_Dataroomtitle5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_accessdataroom_dataroomtitle5(inputs)
});
export { coinvestments_accessdataroom_dataroomtitle5 as "coInvestments_accessDataRoom_dataRoomTitle" }